import { Component, Input } from '@angular/core';
import { FeatureFlagsService } from 'src/app/Common/FeatureFlags/feature-flags-service';

interface IdpCardDetail {
    name: string;
    value: any;
    type?: string;
    apply?: boolean;
    field?: string;
}

export interface IdpCard {
    title: string;
    total: IdpCardDetail;
    details: IdpCardDetail[];
}

@Component({
    selector: 'idp-detail-card',
    templateUrl: './idpDetailCard.component.html',
    styleUrls: ['./idpDetailCard.component.scss'],
    standalone: false,
})
export class IdpDetailCardComponent {
    constructor(private _featureFlagService: FeatureFlagsService) {}
    @Input() detail: IdpCard;
    @Input() disableApplyAll: boolean;
    @Input() isBill: boolean;

    get isCheckboxesEnabled(): boolean {
        return this._featureFlagService.featureFlags.idpModalCheckboxes;
    }
}
